// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary: #000000;
  --color-white: #ffffff;
  --color-red: #ff0000;
  --color-blue: #00a2ed;
  --color-secondary: rgb(34, 34, 34);
  --font-white: rgb(250, 249, 248);
  --font-light-grey: #a4a4a4;
  --font-medium: 18px !important;
  --medium-screen: 640px !important;
  --small-screen: 960px; }

.start-menu {
  height: 80% !important;
  width: 50vw !important;
  top: calc(20% - 40px) !important;
  background: rgba(74, 74, 74, 0.5) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border-radius: 10px !important; }

.start-quick-actions {
  width: 42px !important;
  height: 100% !important; }

.start-app-list {
  width: calc((100%-42px) - 70%); }

.start-tiles {
  width: calc((100%-42px) - 30%);
  height: 100% !important;
  overflow: hidden; }

@media screen and (max-width: 640px) {
  .start-menu {
    width: 100vw !important; }
  .start-app-list {
    width: 0 !important;
    display: none; }
  .start-tiles {
    width: calc(100% - 42px);
    height: 100% !important;
    overflow: hidden; } }

.quick-action-button {
  width: 40px !important;
  height: 40px !important; }

.start-menu-list {
  color: var(--font-white) !important; }

.start-menu-list-item {
  font-size: 14px !important;
  cursor: pointer !important;
  padding: 10px !important; }

.start-menu-list :hover {
  background-color: #323130 !important; }

.profile-card {
  background: #323130 !important; }

.profile-card-img {
  margin-top: calc(-10% - 40px) !important; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/components/startMenu/startMenu.scss"],"names":[],"mappings":"AAAA;EACC,wBAAgB;EAChB,sBAAc;EACd,oBAAY;EACZ,qBAAa;EACb,kCAAkB;EAElB,gCAAa;EACb,0BAAkB;EAElB,8BAAc;EAEd,iCAAgB;EAChB,qBAAe,EAAA;;ACXhB;EACC,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;EAChC,4CAA4C;EAC5C,2DAA2D;EAC3D,sCAAsC;EACtC,8CAA8C;EAC9C,8BAA8B,EAAA;;AAG/B;EACC,sBAAsB;EACtB,uBAAuB,EAAA;;AAGxB;EACC,8BAA8B,EAAA;;AAG/B;EACC,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB,EAAA;;AAGjB;EACC;IACC,uBAAuB,EAAA;EAGxB;IACC,mBAAmB;IACnB,aAAa,EAAA;EAGd;IACC,wBAAwB;IACxB,uBAAuB;IACvB,gBAAgB,EAAA,EAChB;;AAGF;EACC,sBAAsB;EACtB,uBAAuB,EAAA;;AAGxB;EACC,mCAAmC,EAAA;;AAGpC;EACC,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB,EAAA;;AAGzB;EACC,oCAA4C,EAAA;;AAG7C;EACC,8BAAsC,EAAA;;AAGvC;EACC,wCAAwC,EAAA","sourcesContent":[":root {\n\t--color-primary: #000000;\n\t--color-white: #ffffff;\n\t--color-red: #ff0000;\n\t--color-blue: #00a2ed;\n\t--color-secondary: rgb(34, 34, 34);\n\n\t--font-white: rgb(250, 249, 248);\n\t--font-light-grey: #a4a4a4;\n\n\t--font-medium: 18px !important;\n\n\t--medium-screen: 640px !important;\n\t--small-screen: 960px;\n}\n","@import \"../../theme/variables\";\n\n.start-menu {\n\theight: 80% !important;\n\twidth: 50vw !important;\n\ttop: calc(20% - 40px) !important;\n\tbackground: rgba(74, 74, 74, 0.5) !important;\n\tbox-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37) !important;\n\tbackdrop-filter: blur(20px) !important;\n\t-webkit-backdrop-filter: blur(20px) !important;\n\tborder-radius: 10px !important;\n}\n\n.start-quick-actions {\n\twidth: 42px !important;\n\theight: 100% !important;\n}\n\n.start-app-list {\n\twidth: calc((100%-42px) - 70%);\n}\n\n.start-tiles {\n\twidth: calc((100%-42px) - 30%);\n\theight: 100% !important;\n\toverflow: hidden;\n}\n\n@media screen and (max-width: 640px) {\n\t.start-menu {\n\t\twidth: 100vw !important;\n\t}\n\n\t.start-app-list {\n\t\twidth: 0 !important;\n\t\tdisplay: none;\n\t}\n\n\t.start-tiles {\n\t\twidth: calc(100% - 42px);\n\t\theight: 100% !important;\n\t\toverflow: hidden;\n\t}\n}\n\n.quick-action-button {\n\twidth: 40px !important;\n\theight: 40px !important;\n}\n\n.start-menu-list {\n\tcolor: var(--font-white) !important;\n}\n\n.start-menu-list-item {\n\tfont-size: 14px !important;\n\tcursor: pointer !important;\n\tpadding: 10px !important;\n}\n\n.start-menu-list :hover {\n\tbackground-color: rgb(50, 49, 48) !important;\n}\n\n.profile-card {\n\tbackground: rgb(50, 49, 48) !important;\n}\n\n.profile-card-img {\n\tmargin-top: calc(-10% - 40px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
